import {
  action, computed, observable,
} from 'mobx';

import { IGiftMessageData } from '../../api/GiftWrapApi';
import GiftWrapApi from '../../api/GiftWrapApi';
import TransactionRepository from '../TransactionRepository';

export interface IGiftWrapRepositoryConfig {
  giftWrapApi: GiftWrapApi;
  transactionRepository: TransactionRepository;
}
class GiftWrapRepository  {

  private giftWrapApi: GiftWrapApi;

  @observable isLoading = false;

  @observable message = '';

  @observable isMessageLoading = false;

  private transactionRepository: TransactionRepository;

  constructor({
    giftWrapApi,
    transactionRepository,
  }: IGiftWrapRepositoryConfig) {
    this.giftWrapApi = giftWrapApi;
    this.transactionRepository = transactionRepository;
  }

  @action
  public setGiftWrap = async () : Promise<void> => {
    await this.giftWrapApi.setGiftWrap();
    await this.transactionRepository.loadTransaction();
  };

  @action
  public setGiftWrapSku = async (skuId: string) : Promise<void> => {
    await this.giftWrapApi.setGiftWrapSku(skuId);
    await this.transactionRepository.loadTransaction();
  };

  @action
  public handleMessageChange =  (e: React.FormEvent<HTMLTextAreaElement>): void => {
    this.message = e.currentTarget.value;
  };

  @action
  public removeGiftWrap = async () : Promise<void> => {
    await this.giftWrapApi.removeGiftWrap();
    await this.transactionRepository.loadTransaction();
    this.message = '';
  };

  @action
  public setGiftWrapMessage = async (info: IGiftMessageData) : Promise<void> => {
    await this.giftWrapApi.setGiftWrapMessage(info);
  };

  @computed get isGiftWrapLoading(): boolean {
    return this.isLoading;
  }

  @computed get isGiftMessageLoading(): boolean {
    return this.isMessageLoading;
  }

  @action setIsGiftWrapLoading = (isLoading: boolean): void => {
    this.isLoading = isLoading;
  };

  @action setIsGiftWrapMessageLoading = (isLoading: boolean): void => {
    this.isMessageLoading = isLoading;
  };

  @action
  public removeGiftWrapAndGiftWrapMessage = async (): Promise<void> => {
    this.giftWrapApi.removeGiftWrap();
    await this.giftWrapApi.removeGiftWrapMessage();
    await this.transactionRepository.loadTransaction();
    this.message = '';
  };

  @action
  public removeGiftWrapMessage = async (): Promise<void> => {
    await this.giftWrapApi.removeGiftWrapMessage();
    this.message = '';
  };
}

export default GiftWrapRepository;